import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TrueFalseIcon',
  props: {
    active: Boolean,
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})